import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import "./login.css"
import { useDispatch, useSelector } from 'react-redux'
import { toast  , ToastContainer} from 'react-toastify'
import { loginUser } from '../../redux/apiCalls/authApiCall'


function Login() {

   const [email , setEmail] = useState("")
   const [password, setPasword] = useState("");

   const {user} = useSelector(state => state.auth);


   const dispatch = useDispatch();
   const navigate = useNavigate();

   // Form Submit Handler
   const formSubmitHandler = (e)=>{
    e.preventDefault();

    if(email.trim() === "") return toast.error("Email is requierd");
    if(password.trim() ==="") return toast.error("Password is required");

    // console.log({email , password})
    dispatch(loginUser({email, password}));

   }




  return (
    <main className="login-page">
     
      <div className="login-card">
        <h1 className="login-title">Sign in</h1>
        <p className="login-subtitle">Use your account to access the portal</p>

        <form onSubmit={formSubmitHandler} className="login-form">
          <div className="login-field">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e)=> setEmail(e.target.value)}
            />
          </div>
          <div className="login-field">
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e)=> setPasword(e.target.value)}
            />
          </div>
          <div className="login-options">
            <label className="login-remember">
            </label>
          </div>
          <button type="submit" className="login-submit">
            Sign in
          </button>
        </form>

        <p className="login-footer">
          Forget You Password? <Link to="/forget-password">click here</Link>
        </p>
      </div>
    </main>
  )
}

export default Login
